import * as types from '../constants/ActionTypes'

export const errorNotice = payload => ({
  type: types.ERROR_NOTICE,
  payload,
})
